const en = {
  brand: "E2 Care",
  tagline: "Calm, connected care.",
  nav_dashboard: "Dashboard",
  nav_residents: "Patients",
  nav_patients: "Patients",
  nav_rooms: "Rooms",
  nav_buildings: "Buildings",
  imei_label: "IMEI",
  imei_hint: "15 digits, printed on the back of the device",
  imei_length: "The IMEI has 15 digits",
  imei_invalid: "This IMEI is not valid. Check the digits",
  imei_resident_note: "The alarm follows the resident, so it is not assigned to a room.",
  imei_online_hint: "The device appears online after its first keep-alive, within about 5 minutes of being switched on.",
  forgot_link: "Forgot password? Click here",
  forgot_title: "Reset your password",
  forgot_sub: "Enter your email and we'll send you a link to reset your password.",
  forgot_submit: "Send reset link",
  forgot_sent: "If an account exists for this email, we've sent a link to reset your password. Please check your inbox.",
  forgot_back: "← Back to sign in",
  reset_title: "Set a new password",
  reset_sub: "Choose a new password for your account.",
  reset_new_password: "New password",
  reset_confirm_password: "Confirm new password",
  reset_hint: "Use at least 8 characters.",
  reset_submit: "Update password",
  reset_success: "Your password has been updated. Redirecting to sign in…",
  reset_too_short: "Password must be at least 8 characters.",
  reset_mismatch: "Passwords don't match.",
  reset_no_token: "This reset link is invalid or missing. Please request a new one from the sign-in page.",
  reset_failed: "This reset link is invalid or has expired. Please request a new one.",
  nav_devices: "Devices",
  nav_events: "Events",
  nav_alerts: "Alerts",
  nav_users: "Team",
  nav_settings: "Settings",
  nav_admin: "Administration",
  nav_signout: "Sign out",
  topbar_search_placeholder: "Search patients, rooms, devices…",
  admin_super_only: "Only super-administrators can manage organizations.",
  admin_admin_only: "Only administrators can access this page.",
  admin_tab_orgs: "Organizations",
  admin_tab_users: "Users",
  admin_tab_patients: "Patients",
  admin_tab_rooms: "Rooms",
  admin_tab_buildings: "Buildings",
  admin_tab_devices: "Devices",
  admin_tab_device_types: "Device Types",
  admin_tab_alerts: "Alerts",
  admin_dt_title: "Device Types",
  admin_dt_sub: "The device model catalog. Rename a type's display label — the internal key, IoT hub mapping and sync behaviour are unaffected.",
  admin_dt_col_label: "Display label",
  admin_dt_col_key: "Internal key",
  admin_dt_col_category: "Category",
  admin_dt_col_wearable: "Wearable",
  admin_dt_col_ble_sync: "BLE sync",
  admin_dt_col_ble_type_id: "BLE type ID",
  admin_dt_wearable_yes: "Patient-worn",
  admin_dt_wearable_no: "Fixed",
  admin_dt_ble_sync_on: "Required",
  admin_dt_ble_sync_off: "Off",
  admin_dt_edit_label: "Edit label",
  admin_dt_edit_title: "Rename display label",
  admin_dt_edit_desc: "Only the human-readable label changes. Devices, filters and integrations keep using the internal key “{key}”.",
  admin_dt_label_saved: "Label updated.",
  admin_dt_label_required: "Label cannot be empty.",
  admin_dt_load_failed: "Load device types",
  admin_dt_save_failed: "Update label",
  admin_dt_readonly_hint: "Only super-admins can rename device-type labels.",
  sensor_climate: "Climate",
  sensor_temperature: "Temperature",
  sensor_humidity: "Humidity",
  sensor_last_reading: "Last reading",
  sensor_history_title: "Temperature & humidity (48h)",
  sensor_history_empty_title: "No sensor readings yet",
  sensor_history_empty_sub: "Assign an H4 Pro sensor to this room to see climate history.",
  admin_thresholds_title: "Sensor thresholds",
  admin_thresholds_desc: "Temperature & humidity alert boundaries for H4 Pro sensors in this organization.",
  admin_thresholds_temp_min: "Min temperature",
  admin_thresholds_temp_max: "Max temperature",
  admin_thresholds_hum_min: "Min humidity",
  admin_thresholds_hum_max: "Max humidity",
  admin_thresholds_temp_invalid: "Min temperature must be lower than max temperature.",
  admin_thresholds_hum_invalid: "Min humidity must be lower than max humidity.",
  admin_thresholds_hint: "All four are optional — leave a field blank for no alert on that boundary.",
  admin_thresholds_cooldown: "Alert cooldown",
  admin_thresholds_cooldown_placeholder: "Default: 30 min",
  admin_thresholds_cooldown_help: "Minutes between repeated sensor alerts. Leave blank for the system default (30 min).",
  admin_thresholds_cooldown_invalid: "Alert cooldown must be a whole number of at least 1 minute.",
  admin_thresholds_saved: "Sensor thresholds saved.",
  admin_thresholds_load_failed: "Load sensor thresholds",
  admin_thresholds_save_failed: "Save sensor thresholds",
  admin_tab_qa: "Test tools",
  admin_delete: "Delete",
  admin_no_orgs_yet: "No organizations yet.",
  admin_field_name: "Name",
  admin_field_email: "Email",
  admin_field_phone: "Phone",
  admin_field_password: "Password",
  admin_field_role: "Role",
  admin_field_type: "Type",
  admin_field_timezone: "Time zone",
  admin_field_address: "Address",
  admin_field_status: "Status",
  admin_field_organization: "Organization",
  admin_password_keep: "Leave empty to keep current",
  admin_field_birth_date: "Birth date",
  admin_field_room: "Room",
  admin_field_room_none: "Unassigned",
  admin_field_photo: "Photo URL",
  admin_field_photo_hint: "Paste a public image URL — full upload arrives in v2.",
  admin_field_notes: "Caregiver notes",
  admin_field_emergency_contact: "Primary emergency contact",
  admin_field_ec_name: "Name",
  admin_field_ec_phone: "Phone",
  admin_field_ec_relationship: "Relationship",
  admin_field_mac: "MAC address",
  admin_field_firmware: "Firmware",
  admin_field_assignment: "Assigned to",
  admin_field_assigned_room: "Assigned room",
  admin_field_assigned_patient: "Assigned patient",
  admin_field_assigned_hint: "Optional. Sensors usually attach to a room; bracelets to a patient.",
  admin_field_sensor_target: "Mounted on",
  admin_field_sensor_target_hint: "Tells the system whether this sensor watches a door or a window.",
  sensor_target_door: "Door",
  sensor_target_window: "Window",
  sensor_target_unset: "Not configured",
  admin_field_sensor_label: "Sensor label",
  admin_field_sensor_label_hint: "Friendly name shown in alerts and events — e.g. \"Front door\", \"Bathroom window\".",
  admin_field_building: "Building",
  room_activity_view_all: "View all events",
  admin_field_building_required: "A room must belong to a building.",
  room_openings: "Openings",
  room_no_openings: "No door or window sensors installed in this room yet.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Last change",
  admin_field_description: "Description",
  admin_field_severity: "Severity",
  admin_field_patient: "Patient",
  admin_field_device: "Device",
  admin_field_message: "Message",
  admin_orgs_title: "Organizations",
  admin_orgs_sub: "Create, edit and archive tenants of E2 Care.",
  admin_orgs_count: "organizations",
  admin_org_new: "New organization",
  admin_org_new_title: "New organization",
  admin_org_edit_title: "Edit organization",
  admin_org_created: "Organization created.",
  admin_org_updated: "Organization updated.",
  admin_org_deleted: "Organization archived.",
  admin_org_delete_title: "Archive organization?",
  admin_org_delete_confirm: "This will hide \"{name}\" from listings. You can restore it from the database if needed.",
  admin_users_title: "Users",
  admin_users_sub_super: "Manage every user account across all tenants.",
  admin_users_sub_org: "Manage user accounts for {org}.",
  admin_user_new: "New user",
  admin_user_new_title: "New user",
  admin_user_edit_title: "Edit user",
  admin_user_created: "User created.",
  admin_user_updated: "User updated.",
  admin_user_deleted: "User archived.",
  admin_user_delete_title: "Archive user?",
  admin_user_delete_confirm: "\"{name}\" will lose access. Active sessions are not killed.",
  admin_user_memberships: "Organization memberships",
  admin_patients_title: "Patients",
  admin_patients_sub_super: "Manage every patient record across all tenants.",
  admin_patients_sub_org: "Manage patient records in {org}.",
  admin_patient_new: "New patient",
  admin_patient_new_title: "New patient",
  admin_patient_edit_title: "Edit patient",
  admin_patient_created: "Patient created.",
  admin_patient_updated: "Patient updated.",
  admin_patient_deleted: "Patient archived.",
  admin_patient_delete_title: "Archive patient?",
  admin_patient_delete_confirm: "\"{name}\" will be hidden from listings. Care team and family links are preserved.",
  admin_rooms_title: "Rooms",
  admin_rooms_sub_super: "Configure rooms across every tenant.",
  admin_rooms_sub_org: "Configure rooms in {org}.",
  admin_room_new: "New room",
  admin_room_new_title: "New room",
  admin_room_edit_title: "Edit room",
  admin_room_created: "Room created.",
  admin_room_updated: "Room updated.",
  admin_room_deleted: "Room archived.",
  admin_room_delete_title: "Archive room?",
  admin_room_delete_confirm: "\"{name}\" will be hidden. Existing patients keep their assigned_room_id reference.",
  admin_devices_title: "Devices",
  admin_devices_sub_super: "Provision Moko devices across every tenant.",
  admin_devices_sub_org: "Provision Moko devices in {org}.",
  admin_device_new: "New device",
  admin_device_new_title: "New device",
  admin_device_edit_title: "Edit device",
  admin_device_created: "Device created.",
  admin_device_updated: "Device updated.",
  admin_device_deleted: "Device archived.",
  admin_device_delete_title: "Archive device?",
  admin_device_delete_confirm: "Device {mac} will be hidden. Past events and alerts remain in history.",
  admin_buildings_title: "Buildings",
  admin_buildings_sub_super: "Group rooms by physical building / wing across all tenants.",
  admin_buildings_sub_org: "Group rooms by physical building / wing in {org}.",
  admin_building_new: "New building",
  admin_building_new_title: "New building",
  admin_building_edit_title: "Edit building",
  admin_building_created: "Building created.",
  admin_building_updated: "Building updated.",
  admin_building_deleted: "Building archived.",
  admin_building_delete_title: "Archive building?",
  admin_building_delete_confirm: "\"{name}\" will be hidden. Rooms keep their corpus_id reference.",
  admin_qa_title: "Test tools",
  admin_qa_sub: "Inject events / alerts to exercise the dashboard, alert dispatch, and notification channels without poking real Moko devices.",
  admin_qa_event_title: "Inject test event",
  admin_qa_event_sub: "Simulates a Moko device webhook. The backend will run its alert-dispatch pipeline as if the event came from real hardware.",
  admin_qa_alert_title: "Inject test alert",
  admin_qa_alert_sub: "Skips the event layer and writes an alert directly. Use to test the bell, list and Slack/Telegram dispatch.",
  admin_qa_inject_event: "Inject event",
  admin_qa_inject_alert: "Inject alert",
  admin_qa_event_done: "Event injected. Watch the Events page + dashboard.",
  admin_qa_alert_done: "Alert injected. Watch the bell.",
  admin_qa_disclaimer: "These endpoints should be disabled or feature-flagged in production.",
  admin_alerts_title: "Alerts policy",
  admin_alerts_sub: "Org-wide alerting rules for {org}. Applied to every patient in this tenant.",
  admin_alerts_quiet_title: "Quiet hours",
  admin_alerts_quiet_desc: "Define when this organization is in \"night mode\". Useful for routing non-critical alerts more quietly.",
  admin_alerts_quiet_hint: "Times are interpreted in the organization’s local time zone. Range may wrap past midnight (e.g. 22:00 → 06:00).",
  admin_alerts_night_start: "Night starts",
  admin_alerts_night_end: "Night ends",
  admin_alerts_load_failed: "Load alert policy",
  admin_alerts_save_failed: "Save alert policy",
  admin_alerts_saved: "Alert policy saved.",
  admin_alerts_clear_title: "Clear active alerts",
  admin_alerts_clear_desc: "Acknowledge every open alert across this organization in one click.",
  admin_alerts_clear_hint: "Useful after a planned drill or a misconfigured sensor that produced a wave of false positives. Acknowledged alerts stay in history.",
  admin_alerts_ack_all_button: "Acknowledge all",
  admin_alerts_ack_all_title: "Acknowledge all active alerts?",
  admin_alerts_ack_all_confirm: "This will mark every open alert in {org} as acknowledged. This action cannot be undone.",
  admin_alerts_ack_all_done: "{count} alert(s) acknowledged.",
  admin_alerts_ack_all_done_generic: "All active alerts acknowledged.",
  admin_alerts_ack_all_failed: "Acknowledge all alerts",
  org_type_nursing_home: "Nursing home",
  org_type_assisted_living: "Assisted living",
  org_type_hospital: "Hospital",
  org_type_home_care: "Home care",
  role_admin: "Admin",
  role_super_admin: "Super Admin",
  role_caregiver: "Caregiver",
  role_family: "Family",
  status_active: "active",
  status_inactive: "inactive",
  confirm: "Confirm",
  sign_in: "Sign in",
  signed_in: "Signed in",
  sign_up: "Sign up",
  email: "Email",
  password: "Password",
  full_name: "Full name",
  create_account: "Create account",
  no_account: "No account yet?",
  have_account: "Already have an account?",
  login_welcome: "Welcome back",
  login_sub: "Sign in to continue monitoring your residents.",
  register_welcome: "Join E2 Care",
  register_sub: "Create your caregiver workspace in under a minute.",
  total_residents: "Patients",
  active_devices: "Active devices",
  open_alerts: "Open alerts",
  offline_gateways: "Offline devices",
  falls_7d: "Falls (7d)",
  sos_7d: "SOS (7d)",
  low_battery: "Low battery",
  critical_residents: "Critical",
  status_ok: "All clear",
  status_warning: "Attention",
  status_critical: "Critical",
  status_online: "Online",
  status_offline: "Offline",
  search: "Search",
  filter: "Filter",
  all: "All",
  refresh: "Refresh",
  loading: "Loading…",
  no_results: "Nothing here yet.",
  view_profile: "View profile",
  showing_n_of_m: "Showing {n} of {m}",
  load_more: "Load more",
  auto_refresh: "Live · auto-refresh",
  live: "Live",
  nav_home: "Home",
  family_home_kicker: "Family view",
  family_home_title: "Your loved ones",
  family_greeting: "Hello",
  family_home_sub: "A calm overview of how everyone is doing.",
  family_status_ok: "is doing fine",
  family_status_attention: "needs attention",
  family_all_calm: "All calm right now.",
  family_attention_sub: "Let's check in on them — details below.",
  family_last_seen: "last seen",
  family_latest_alert: "Latest alert",
  family_no_alerts: "No recent alerts — all is well.",
  family_view_details: "View details",
  family_no_device: "No personal alarm linked yet.",
  auto_refresh_paused: "Paused (load more active)",
  updated_just_now: "Updated just now",
  updated_n_sec_ago: "Updated {n}s ago",
  updated_n_min_ago: "Updated {n}m ago",
  acknowledge: "Acknowledge",
  acknowledged: "Acknowledged",
  ack_all: "Acknowledge all",
  ack_all_confirm: "Acknowledge all {count} active alert(s)?",
  ack_all_running: "Acknowledging…",
  ack_all_done: "{count} alert(s) acknowledged.",
  ack_all_partial: "{ok} acknowledged · {fail} failed.",
  last_seen: "Last seen",
  battery: "Battery",
  signal: "Signal",
  device_personal_alarm: "Personal Alarm",
  device_charging: "Charging",
  device_location: "Location",
  device_current_location: "Current location",
  device_no_location: "No location reported yet.",
  device_location_source: "Source",
  device_location_updated: "Updated",
  device_track_1h: "1h",
  device_track_24h: "24h",
  device_track_7d: "7d",
  device_track_last: "Last position",
  device_located: "Located",
  map_sos: "SOS alert",
  map_fall: "Fall detected",
  map_current: "Current position",
  firmware: "Firmware",
  room: "Apt / Room",
  age: "Age",
  emergency_contact: "Emergency contact",
  notes: "Notes",
  assigned_devices: "Assigned devices",
  assign_device: "Assign device",
  select_device: "Select a device…",
  admin_patient_no_devices_assigned: "No devices assigned.",
  admin_patient_no_wearables: "No wearable devices available in this organization.",
  admin_patient_device_reassign: "reassign",
  recent_events: "Recent events",
  timeline_24h: "Last 24 hours",
  delivery_status: "Delivery status",
  acknowledged_by: "Acknowledged by",
  dashboard_title: "Home overview",
  dashboard_sub: "A quick read of everything happening across the homes you care for.",
  residents_title: "Patients",
  residents_sub: "People you are monitoring right now.",
  devices_title: "Devices",
  devices_sub: "Sensors and tags.",
  devices_sub_admin: "Gateways, sensors and tags.",
  events_title: "Live events",
  events_sub: "Chronological feed from every connected device.",
  alerts_title: "Alerts",
  alerts_sub: "Notifications escalated to family and caregivers.",
  settings_title: "Settings",
  settings_sub: "Your preferences and notification rules.",
  users_title: "Team",
  users_sub: "Caregivers, family and admins with access.",
  falls_chart_title: "Falls & SOS — last 7 days",
  recent_alerts_title: "Recent critical alerts",
  recent_critical_alerts_title: "Recent critical alerts",
  no_alerts: "No open alerts. Everyone is safe.",
  event_fall: "Fall detected",
  event_sos: "SOS button pressed",
  event_door_open: "Door opened",
  event_door_close: "Door closed",
  event_inactivity: "Prolonged inactivity",
  event_low_battery: "Low battery",
  event_offline: "Device offline",
  event_online: "Device back online",
  event_heartbeat: "Heartbeat",
  event_button_press: "Button pressed",
  event_charging: "Charging started",
  event_sos_cancel: "SOS cancelled",
  event_call: "SOS call",
  alert_timeline: "Alert timeline",
  alert_trigger: "Trigger",
  alert_calls: "Calls",
  alert_view_timeline: "View timeline",
  reopen: "Reopen",
  reopened: "Alert reopened",
  alert_no_deliveries: "No notifications sent yet.",
  alert_cancelled_on_device: "SOS was cancelled on the device — the alert stays open until a caregiver resolves it.",
  call_answered: "Answered",
  call_missed: "Missed",
  device_gateway: "Bluetooth gateway",
  device_door_sensor: "Door sensor",
  device_bracelet: "Bracelet",
  device_unknown: "Unknown device",
  language: "Language",
  notifications: "Notifications",
  quiet_hours: "Quiet hours",
  escalation: "Escalation policy",
  just_now: "just now",
  rel_prefix: "",
  min_ago: "min ago",
  h_ago: "h ago",
  d_ago: "d ago",
  demo_hint: "Demo account: admin@e2care.lv / Care2024!",
  open_menu: "Open menu",
  close_menu: "Close menu",
  care_team: "Care team",
  family_members: "Family",
  no_caregivers: "No caregivers assigned yet.",
  no_family: "No family members linked yet.",
  add_caregiver: "Add caregiver",
  add_family: "Add family member",
  select_user: "Select a user…",
  cancel: "Cancel",
  add: "Add",
  remove: "Remove",
  save: "Save",
  relationship: "Relationship",
  relationship_son: "Son",
  relationship_daughter: "Daughter",
  relationship_spouse: "Spouse",
  relationship_other: "Other",
  notify_via: "Notify via",
  call_contact: "Call contact",
  view_resident: "Open profile",
  address: "Address",
  admin_only_section: "Admin tools",
  rooms_title: "Rooms",
  rooms_sub: "Every room you supervise — patients, devices and current state.",
  rooms_building_clear: "Clear filter",
  buildings_title: "Buildings",
  buildings_sub: "Every building you supervise, with its rooms, patients and devices.",
  buildings_view_rooms: "View rooms",
  room_name: "Room",
  room_type: "Type",
  room_type_private_room: "Private room",
  room_type_shared_room: "Shared room",
  room_type_apartment: "Apartment",
  room_type_corridor: "Corridor",
  room_type_common_area: "Common area",
  room_floor: "Floor",
  room_state: "Current state",
  door: "Door",
  window: "Window",
  door_open_state: "Open",
  door_closed_state: "Closed",
  door_unknown_state: "Unknown",
  room_no_devices: "No devices in this room yet.",
  room_no_patients: "No patients assigned to this room yet.",
  room_patients: "Patients in room",
  room_devices: "Devices in room",
  room_activity: "Activity timeline",
  rooms_filter_all_types: "All types",
  widget_active_alerts: "Active alerts",
  widget_active_alerts_sub: "Critical, unresolved and acknowledged",
  widget_patients_status: "Patients status",
  widget_devices_health: "Devices health",
  widget_room_activity: "Room activity",
  widget_recent_events: "Live event feed",
  widget_connectivity: "Connectivity",
  metric_critical: "Critical",
  metric_unresolved: "Unresolved",
  metric_acknowledged_count: "Acknowledged",
  metric_total: "Total",
  metric_active: "Active",
  metric_online: "Online",
  metric_offline: "Offline",
  metric_ota_pending: "OTA pending",
  metric_battery_warn: "Battery low",
  metric_doors_open: "Doors open",
  metric_windows_open: "Windows open",
  metric_signal_avg: "Avg signal",
  metric_last_comm: "Last comm",
  metric_packets: "Packets / hr",
  view_all: "View all",
  status_new: "New",
  status_acknowledged: "Acknowledged",
  status_resolved: "Resolved",
  status_resolved_local: "Resolved (local)",
  resolve: "Resolve",
  add_note: "Add note",
  save_note: "Save note",
  resolve_local_badge: "this device only",
  resolve_local_hint: "Marks the alert as resolved in your browser only. The backend and other team members still see it as open.",
  note_placeholder: "Add context for the team…",
  notes_count: "{n} note(s)",
  device_detail: "Device detail",
  device_diagnostics: "Diagnostics",
  device_firmware_history: "Firmware history",
  device_ota_config: "OTA configuration",
  device_ota_status: "OTA status",
  device_signal: "Signal quality",
  device_mac: "MAC address",
  device_serial: "Serial number",
  fall_sensitivity: "Fall sensitivity",
  transmission_interval: "Transmission interval",
  low_battery_threshold: "Low battery threshold",
  ota_idle: "Idle",
  ota_pending: "Pending",
  ota_deploying: "Deploying",
  ota_failed: "Failed",
  events_filter_severity: "Severity",
  events_filter_room: "Room",
  events_filter_patient: "Patient",
  events_filter_device: "Device",
  severity_info: "Info",
  severity_warning: "Warning",
  severity_critical: "Critical",
  telegram_title: "Telegram alerts",
  telegram_desc: "Receive alerts on Telegram for residents you are assigned to.",
  telegram_connect: "Connect Telegram",
  telegram_connected: "Telegram connected",
  telegram_connected_as: "Connected to Telegram as {name}",
  telegram_connect_success: "Telegram connected successfully",
  telegram_connect_error: "Could not connect Telegram. Please try again.",
  telegram_missing_bot: "Telegram bot not configured. Set REACT_APP_TELEGRAM_BOT in the env file.",
  telegram_disconnect: "Disconnect",
  telegram_disconnect_success: "Telegram disconnected.",
  telegram_disconnect_error: "Could not disconnect Telegram. Please try again.",
  telegram_already_linked: "This Telegram account is already linked to another e2-care user.",
  telegram_switch_q: "Use a different Telegram account?",
  telegram_switch_intro: "Telegram remembers which account is signed in across all websites. To use a different one:",
  telegram_switch_step1: "Open Telegram Web and log out of your current account.",
  telegram_switch_step2: "Return here and reload the button below, then sign in with the other account.",
  telegram_open_web: "Open Telegram Web",
  telegram_reload_widget: "I logged out — reload the button",
  lang_autodetected_toast: "Detected your language as {language}. You can change it in Settings.",
  admin_view_active: "Active",
  admin_view_archived: "Archived",
  admin_restore: "Restore",
  admin_restored: "Restored.",
  admin_hard_delete: "Delete permanently",
  admin_hard_delete_title: "Delete permanently?",
  admin_hard_delete_confirm: "This will permanently remove \"{name}\" from the database. This action cannot be undone.",
  admin_hard_deleted: "Permanently deleted.",
  admin_no_archived: "No archived items.",
  language_desc: "Used for the app interface and your Telegram + push notifications.",
  language_saved: "Language updated.",
  language_error: "Could not update language. Please try again.",
  admin_field_language: "Language",
  edit: "Edit",
  generic_error: "Something went wrong. Please try again.",
  caregiver_added: "Caregiver added.",
  caregiver_removed: "Caregiver removed.",
  family_added: "Family member added.",
  family_removed: "Family member removed.",
  menu: "Menu",
  dl_companion_app: "Companion app",
  dl_hero_title: "E2 Care for Android",
  dl_hero_sub: "Install the companion app on a Moko-equipped phone to relay alerts, configure devices and stay connected to your care team — even when the dashboard is closed.",
  dl_android_apk: "Android APK",
  dl_version_loading: "version loading…",
  dl_released: "Released {date}",
  dl_download_apk: "Download APK",
  dl_unavailable: "Unavailable",
  dl_preparing: "Preparing…",
  dl_manifest_error: "Couldn’t load the manifest. Try refreshing — if the issue persists the build server may be redeploying.",
  dl_whats_new: "What’s new",
  dl_installing_title: "Installing on your phone",
  dl_step1: "Tap “Download APK” above. Your browser may warn that APK files can harm your device — that warning is normal for any installer downloaded outside the Play Store.",
  dl_step2: "Open the downloaded file. Android will ask you to allow installations from this browser the first time — toggle the permission, then come back.",
  dl_step3: "Tap “Install”, then “Open” when it finishes.",
  dl_step4: "Sign in with your E2 Care credentials.",
  dl_iphone_note: "iPhone version coming later. For now, please use the web dashboard.",
  dl_back_to_dashboard: "Back to dashboard",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Changing the organization clears the current room and patient assignment.",
  admin_view_full: "Full list",
  device_filter_assignment: "Assignment",
  device_filter_patient: "Assigned to patient",
  device_filter_room: "Assigned to room",
  device_filter_unassigned: "Unassigned",
  admin_all_orgs: "All organizations",
  pagination_prev: "Previous",
  pagination_next: "Next",
  pagination_per_page: "Per page",
  pagination_page_of: "Page {page} of {pages}",
  pagination_total: "{total} total",
  status_never_reported: "Never reported",
  mv_title: "Movement",
  mv_sub: "From {n} motion sensor(s) · 5-minute windows",
  mvo_title: "Movement at a glance",
  mvs_moving: "{name} is up and about",
  mvs_moving_sub: "Moved {when}",
  mvs_rest: "{name} is resting",
  mvs_rest_sub: "Last moved {when}",
  mvs_rest_sub_none: "No movement in the last 30 days",
  mvs_quiet: "{name} has been quiet for longer than usual",
  mvs_quiet_sub: "No movement for {dur}. A quick check-in may be worth it.",
  mvs_short_quiet: "Quiet for long",
  mvs_room_moving: "Someone is moving in {name}",
  mvs_room_rest: "{name} is calm",
  mvs_room_quiet: "No movement in {name} for longer than usual",
  mvs_sensor: "The movement sensor isn't sending",
  mvs_sensor_sub: "This is about the sensor, not about {name}. Last signal {when}.",
  mvs_nodata: "No movement data yet",
  mvs_nodata_sub: "The movement sensor hasn't sent anything yet.",
  mvd_title: "Last 24 hours",
  mvd_moving: "Moving",
  mvd_resting: "Resting",
  mvd_nosignal: "No signal",
  mvd_night: "Night",
  mvd_now: "Now",
  mvn_title: "Last 7 nights",
  mvn_last_night: "Last night",
  mvn_last_short: "Last",
  mvn_calm: "Calm",
  mvn_restless: "Restless",
  mvn_still: "Very still",
  mvn_silent: "Sensor quiet",
  mvn_nodata: "No data",
  mvn_s_calm_none: "Calm night, no movement between {from} and {to}.",
  mvn_s_calm_once: "Calm night, up once around {at}.",
  mvn_s_calm_many: "Calm night, up {n} times, first around {first}, last around {last}.",
  mvn_s_restless: "Restless night, up {n} times between {first} and {last}.",
  mvn_s_still: "Very still night, less movement than usual. Longest rest {dur}.",
  mvn_s_still_moved: "Very still night, moved only around {at}. Longest rest {dur}.",
  mvn_s_silent: "The sensor was mostly quiet, so we can't tell how this night went.",
  mvn_s_nodata: "No movement data for this night.",
  mv_state_moving: "Moving",
  mv_state_still: "Resting",
  mv_state_inactive: "Inactive",
  mv_state_silent: "Sensor not reporting",
  mv_state_never: "Never reported",
  mv_state_nodata: "No data yet",
  mv_state_no_sensor: "No motion sensor",
  mv_last_movement: "Last movement",
  mv_last_sample: "Sensor last heard",
  mv_none_in_retention: "None in the last 30 days",
  mv_silent_hint: "No sample for over {min} min — check the sensor or its gateway. This is a device fault, not stillness.",
  mv_inactive_hint: "No movement for over {min} min while the sensor is still reporting.",
  mv_history: "Movement history",
  mv_history_empty: "No motion data in this range yet.",
  mv_not_reporting: "Not reporting",
  mv_no_movement: "No movement",
  mv_detections: "motion detections",
  mv_legend_motion: "Motion detections",
  mv_legend_gap: "Not reporting",
  mv_retention_note: "History kept 30 days",
  mv_strip_title: "Live movement",
  mv_strip_sub: "{n} motion sensor(s)",
  mv_unassigned: "Unassigned sensor",
  admin_alerts_timezone: "Organisation time zone",
  admin_alerts_timezone_invalid: "Choose a valid IANA time zone.",
  admin_alerts_night_wrap_hint: "Night hours run from {start} to {end} the next morning ({tz}), i.e. after {start} or before {end}.",
  admin_alerts_night_same_day_hint: "Night hours run from {start} to {end} on the same day ({tz}).",
  admin_alerts_night_equal: "Start and end can't be the same time.",
  admin_alerts_inactivity_label: "Inactivity threshold",
  admin_alerts_inactivity_question: "Has this person moved? Minutes without movement before it becomes alertable.",
  admin_alerts_silence_label: "Device silence threshold",
  admin_alerts_silence_question: "Is this sensor still talking? Minutes without any sample before it counts as a device fault, not an inactive resident.",
  admin_alerts_minutes: "minutes",
  admin_alerts_threshold_invalid: "Enter a whole number greater than 0.",
  admin_alerts_thresholds_provisional: "Starting values (180 / 30 min) have not been tuned yet — adjust them for your residents.",
  admin_tab_gateways: "Gateways",
  gw_title: "Gateways",
  gw_status_deactivated: "Deactivated",
  gw_scope_pending: "Gateways for your organization will appear here once the backend update is live.",
  gw_none_for_org: "No gateway assigned to this organization yet.",
  gw_col_room: "Room",
  gw_unassigned: "Unassigned",
  gw_never: "Never",
  gw_edit_title: "Edit gateway",
  gw_new_title: "New gateway",
  gw_super_field: "Only a super-admin can change this",
  gw_mac_invalid: "Enter 12 hexadecimal characters, e.g. AA:BB:CC:DD:EE:FF",
  gw_hw_type: "Hardware type",
  gw_notes: "Notes",
  gw_manage_sub: "BLE hubs relaying sensor data: health, organization and room. A silent gateway makes every sensor behind it look silent.",
  gw_filter_all: "All organizations",
  gw_new: "New gateway",
  gw_col_assignment: "Organization · Room",
  gw_backend_pending: "This needs the backend update that is not deployed yet.",
  gw_save_failed: "Save gateway",
  gw_created: "Gateway created",
  gw_saved: "Gateway saved",
  gw_reactivated: "Gateway reactivated",
  gw_deactivated: "Gateway deactivated",
  gw_reactivate: "Reactivate",
  gw_deactivate: "Deactivate",
  gw_reactivate_title: "Reactivate {name}?",
  gw_deactivate_title: "Deactivate {name}?",
  gw_reactivate_desc: "It will count in status and alerts again.",
  gw_deactivate_desc: "It stops counting in status and alerts. Its history is kept and you can reactivate it at any time.",
  gw_heard_title: "Devices it hears",
  gw_heard_sub: "Sensors this gateway relayed in the last 24 hours.",
  gw_heard_none: "No device heard in the last 24 hours.",
  gw_heard_unknown: "Unknown devices heard",
  gw_msgs_short: "msgs",
  gw_avg: "avg",
  gw_samples_short: "samples",
  gw_not_found: "Gateway not found or not visible to you.",
  gw_one: "Gateway",
  gw_manage_link: "Manage in Administration",
  gw_rssi_range: "Signal range",
  gw_longest_gap: "Longest gap",
  gw_config_push: "Last config push",
  gw_sub: "BLE hubs relaying sensor data. Read-only — a silent gateway makes every sensor behind it look silent.",
  gw_super_only: "Gateway status is available to super-admins only.",
  gw_load_failed: "Load gateways",
  gw_status_reporting: "Reporting",
  gw_status_silent: "Silent",
  gw_status_never_seen: "Never seen",
  gw_returned: "Back after a {h} h gap (ended {at})",
  gw_count_reporting: "{n} reporting",
  gw_count_silent: "{n} silent",
  gw_count_never: "{n} never seen",
  gw_count_deactivated: "{n} deactivated",
  gw_window: "Stale after {h} h without a message",
  gw_col_name: "Gateway",
  gw_col_status: "Status",
  gw_col_msgs: "Messages 24h",
  gw_col_discard: "Discarded",
  gw_last_message: "Last message",
  gw_devices_seen: "Devices seen",
  gw_hours_active: "Hours active",
  gw_unregistered_title: "Reporting without a registry entry",
  gw_unregistered_desc: "These identifiers appear in gateway activity but have no gateway record (e.g. a unit reporting under an IMEI). Totals from the two sources legitimately differ.",
  nav_reports: "Reports",
  rep_night_title: "Night summary",
  rep_night_desc: "A morning recap of each resident's movement during the organisation's night hours, and any time a sensor went silent.",
  rep_last_night: "Last night",
  rep_nights_ago: "{n} nights ago",
  rep_policy_fallback: "default night hours (policy unavailable)",
  rep_movement: "Movement",
  rep_windows: "Active 5-min windows: {n}",
  rep_no_movement: "No movement",
  rep_first_movement: "First movement",
  rep_longest_still: "Longest still stretch",
  rep_silences: "Sensor silences",
  rep_none: "None",
  rep_coverage: "{pct}% reported",
  rep_night_note: "Times are in the organisation's time zone. Stillness is only counted while the sensor was reporting; silences of at least the device silence threshold are listed separately.",
  dh_reporting_title: "Reporting health",
  dh_never_reported_desc: "Registered but has never reported. This is a provisioning gap, not an offline device.",
  dh_interval_still: "Measured interval (still)",
  dh_interval_moving: "Measured interval (moving)",
  dh_interval_samples: "Measurement samples",
  dh_interval_unmeasured: "No measured interval yet — the organisation's device silence threshold applies.",
  dh_interval_note: "Intervals are measured from received messages, not the configured default.",
  rep_dur_h_min: "{h} h {m} min",
  rep_dur_min: "{m} min",
  rep_shared_room: "Shared room — may include others' movement",
  rep_no_data_night: "No data for this night — the sensor was not reporting (or not yet installed).",
  wt_title: "Week trend",
  wt_desc: "Seven nights side by side per resident — or per shared room — to spot restless or unusually still nights against their usual pattern.",
  wt_baseline_note: "flags compare each night to that row's 7-night median",
  wt_no_sensors: "No resident has a motion sensor yet.",
  wt_flag_restless: "Restless",
  wt_flag_still: "Unusually still",
  wt_flag_nodata: "No data",
  wt_flag_silent: "Sensor mostly silent",
  rep_sensor_silent: "The sensor reported for only {pct}% of this night. The gaps mean the sensor stopped reporting, not that the resident was still.",
  wt_legend_active: "Active 5-min windows",
  wt_legend_still: "Longest still stretch (h)",
  fap_title: "Family members can handle alerts",
  fap_desc: "When on, family members can acknowledge, resolve, reopen and add notes to alerts of their own residents in {org}.",
  note_saved: "Note saved",
  event_device_silent: "Sensor stopped reporting",
  event_no_movement: "No movement",
  event_no_rise: "No movement after the night",

  dur_lt_min: "less than a minute",
  dur_min: "{m} min",
  dur_h: "{h} h",
  dur_h_min: "{h} h {m} min",
  am_fall: "Fall detected",
  am_sos: "SOS button pressed",
  am_low_battery: "Device battery low",
  am_low_battery_dev: "Battery low on {device}",
  am_door: "Door open",
  am_door_in: "Door open in {place}",
  am_door_in_detail: "Door open in {place} ({detail})",
  am_window: "Window open",
  am_window_in: "Window open in {place}",
  am_window_in_detail: "Window open in {place} ({detail})",
  am_silent: "Motion sensor in {place} stopped reporting about {dur} ago — check its power or its gateway",
  am_silent_nodur: "Motion sensor in {place} stopped reporting — check its power or its gateway",
  am_nomove: "No movement detected in {place} for about {dur}",
  am_nomove_nodur: "No movement detected in {place}",
  am_norise: "No movement detected in {place} since the night ended (normally up by {time})",
  am_norise_notime: "No movement detected in {place} since the night ended",
  amf_silent_res: "{name}'s movement sensor hasn't reported since {time}, so movement isn't being tracked at the moment.",
  amf_silent_room: "The movement sensor in {place} hasn't reported since {time}, so movement isn't being tracked there at the moment.",
  amf_sensor_ok: "The sensor is working; it just hasn't seen anyone move.",
  amf_team: "The care team has been alerted on their dashboard.",
  amf_contact_device: "You're listed as the contact for this device.",
  amf_contact_resident: "You're listed as the contact for {name}.",
  al_tab_care: "Care",
  al_tab_maint: "Maintenance",
  al_maint_hint: "Sensors that stopped reporting and low batteries: technical work, not care events.",
  al_maint_empty: "No sensor or battery problems.",
  al_auto_closed: "Closed automatically",
  al_auto_closed_reason: "Closed automatically — {reason}",
  al_never_seen: "nobody saw it before it closed",
  al_resolved_by: "Resolved by {name}",
  al_reason_movement: "movement resumed",
  al_reason_sensor: "sensor reporting again",
  al_admin_only_ack: "Only an admin can handle this alert, because it isn't linked to a single resident.",
  why_title: "Why did this fire?",
  why_since_motion: "Since last movement",
  why_since_sample: "Since the sensor last reported",
  why_threshold: "Threshold",
  why_up_by: "Normally up by",
  why_night: "Night window",
  why_source: "Threshold set by",
  why_src_org: "this organisation",
  why_src_default: "default values",
  why_state: "Sensor state",
  why_checked: "Checked at",
  why_approx: "Checks run every 5 minutes, so alert times are approximate.",
  mon_label: "Movement monitoring",
  mon_active: "active",
  mon_down: "not reporting",
  mon_down_since: "not reporting since {time}",
  admin_alerts_up_by_label: "Normally up by",
  admin_alerts_up_by_question: "If no movement is seen between the end of the night and this time, a 'no movement since the night ended' alert is raised.",
  admin_alerts_up_by_invalid: "Must be later than the end of the night ({end}): it is the hour residents are normally up, after the night is over.",
  admin_alerts_up_by_format: "Enter a time as HH:MM.",
  admin_alerts_escalation_label: "Tell family about a silent sensor after",
  admin_alerts_escalation_question: "Staff see a silent sensor straight away. Family are told only if it is still unresolved after this long (immediately if the organisation has no caregivers).",
  admin_alerts_cooldown_note: "After an alert closes, the same alert can come back once its threshold has passed again. The morning alert fires at most once a day.",
  admin_alerts_stored_invalid: "The saved 'normally up by' time ({up}) is not after the end of the night ({end}), so morning alerts cannot run and this policy cannot be saved until it is fixed.",
  admin_alerts_defaults_badge: "Using default values",

  fap_auto_on: "Automatic: on, because this organization has no caregivers.",
  fap_auto_off: "Automatic: off, because this organization has caregivers.",
  fap_manual: "Set by an admin.",
  fap_reset: "Back to automatic",
  fap_saved: "Saved",
  fap_save_failed: "Could not save. Please try again.",
  fap_pending: "Coming soon",
  fap_retry: "Retry",
  recap_title: "Morning night recap",
  recap_desc_staff: "Every day at 07:00 (organisation time) a summary of last night for every resident in your organisation.",
  recap_desc_family: "Every day at 07:00 (organisation time) a summary of last night for your loved ones.",
  recap_on: "On",
  recap_off: "Off",
  recap_email: "Email",
  recap_telegram_link_first: "Connect Telegram above to receive it there.",
  recap_no_channel: "Pick at least one channel, or nothing will be sent.",
  recap_last_sent: "Last sent {at}",
  recap_saved: "Recap preferences saved.",
  recap_save_failed: "Could not save recap preferences.",
  recap_unavailable: "Coming soon",
  topbar_org_label: "Organization",
  device_ota_phase2: "OTA deployment becomes interactive in Phase 2.",
  event_window_open: "Window opened",
  event_window_close: "Window closed",
  event_alarm_end: "Alarm ended",
  wt_h: "h",
  wt_load_failed: "Couldn't load motion history. Try again later.",
  recap_load_failed: "Couldn't load recap settings — tap to retry.",
  mv_shared_note: "This resident shares a room. A room sensor can't tell residents apart, so movement is shown for the room, not for one person.",
  mv_shared_link: "See movement for {room}",
  mv_room_shared_note: "Shared by {n} residents — this movement can't be attributed to any one of them.",
  rep_shared_room_row: "Shared room · {names}",
  admin_motion_resident: "Bedside sensor for a resident",
  admin_motion_resident_hint: "Optional. Pick a resident only if this sensor watches their personal area (e.g. aimed at their bed). Their movement charts then use it, even in a shared room.",
  admin_motion_whole_room: "Whole room",
};
export default en;
